import React from "react";
import {Route, Switch} from "react-router-dom";
import ViewPolicyDetails from "./ViewPolicyDetails";
import UpdatePolicyDetails from "./UpdatePolicyDetails";
import ViewCompleteDetails from "./ViewCompleteDetails";
import EditPolicyDetails from "./EditPolicyDetails";


const App = ({match}) => (
  <Switch>
    <Route exact path={`${match.url}`} component={ViewPolicyDetails} />
    <Route path={`${match.url}/details`} component={UpdatePolicyDetails}/>
    <Route path={`${match.url}/views/:id?`} component={ViewCompleteDetails}/>
    <Route path={`${match.url}/editDetails/:id?`} component={EditPolicyDetails}/>
  </Switch>
);

export default App;